<template>
  <div id="app">
    <!-- <router-view /> -->
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>

<script>
export default {
  name: 'app',
  mounted: function() {}
}
</script>
<style lang="stylus">
.el-progress__text {
  font-size: 20px;
  color: #fff;
}

.login-footer-s .el-checkbox__input.is-checked .el-checkbox__inner {
  background-color: #478BFD;
  border-color: #478BFD;
}

.login-footer-s .el-checkbox__input.is-checked+.el-checkbox__label {
  color: #478BFD;
}

.more-export {
  text-align: center;
}

.more-export button {
  width: 100px;
}

.el-year {
  border: 1px solid #ededed;
  text-align: center;
  padding: 5px;
}

.export-title {
  font-weight: bold;
  font-size: 15px;
}

.el-allData {
  text-align: center;
}

.el-allData .el-dialog {
  width: 400px;
}

.el-btn-m {
  padding: 20px 0;
}

.el-btn-m .el-col-6>.el-checkbox, .el-btn-m .el-col-12>.el-checkbox, .el-btn-m .el-col-24>.el-checkbox {
  border: 1px solid #ededed;
  padding: 3px 0;
  border-radius: 2px;
  width: 80px;
  margin-bottom: 10px;
}

.el-btn-m .el-col-6>.is-checked, .el-btn-m .el-col-12>.is-checked, .el-btn-m .el-col-24>.is-checked {
  background: #53a0e9;
  border: 1px solid #53a0e9;
}

.el-btn-m .el-checkbox__input {
  opacity: 0;
  position: absolute;
}

.el-btn-m .el-col-6 .el-checkbox__input.is-checked+.el-checkbox__label, .el-btn-m .el-col-12 .el-checkbox__input.is-checked+.el-checkbox__label, .el-btn-m .el-col-24 .el-checkbox__input.is-checked+.el-checkbox__label {
  color: #fff;
  padding-left: 0;
}

.el-allData .el-dialog__body {
  padding-top: 10px !important;
}

.el-allData .el-dialog__header {
  text-align: center;
}

.el-allData .el-col-1:hover {
  cursor: pointer;
}

.el-icon-question {
  cursor: pointer;
}

.formSerch .el-input--medium .el-input__inner {
  width: 140px;
}

.non-reset .el-date-editor.el-input {
  width: 140px;
}

.privice-tiem {
}

.top-div {
  position: relative;
}

.privice-tiem {
  position: absolute;
  right: 10px;
  top: -6px;
}

.bottom-col {
  padding-bottom: 30px;
}

.privice-tiem button {
  margin-left: 10px;
}

.more-export .el-button--primary {
  background: #53a0e9;
}

.bottom-top {
  color: #333;
  padding: 0px 10px;
  font-size: 12px;
}

.bottom-top img {
  vertical-align: middle;
  margin-top: -5px;
}

.bottom-top div {
  margin-top: 7px;
}

.bottom-top span {
  color: #111111;
  margin-left: 5px;
  font-size: 14px;
  font-weight: bold;
}

.el-allData .el-dialog__headerbtn {
  display: none;
}

.nohave {
  margin: 0 auto;
  font-family: PingFangSC-Regular;
  font-size: 16px;
  color: #999999;
  letter-spacing: 0.89px;
  text-align: center;
  margin-top: 55%;
}

.map-n {
  background: rgba(0, 0, 0, 0.5);
  border: 1px solid #333333;
  border-radius: 4px;
  height: 36px;
  width: 100px;
  line-height: 36px;
  text-align: center;
  font-size: 14px;
  font-weight: bold;
  color: #FFFFFF;
  position: absolute;
  top: 50%;
  left: 45%;
}

.map-data .map-area[data-v-], .map-data .map-area {
  width: 80% !important;
}

.el-select-dropdown__item {
  height: 48px !important;
  line-height: 46px;
}

.el-select-dropdown__list {
  padding-top: 0 !important;
  height: auto !important;
}

.hd-c .mark-l.el-form-item--medium .el-form-item__content .el-input--medium {
  margin-left: -20px !important;
}

.hd-c .mark-l .el-form-item__label {
  width: 60px !important;
}

.l-d {
  position: absolute;
  left: 15px;
  width: 300px;
  top: 85px;
  height: 86%;
  background: #2b304c;
  border: 1px solid #3c4161;
  box-shadow: 0 5px 5px 0 rgba(0, 0, 0, 0.1);
  font-size: 14px;
  z-index: 100;
  overflow: hidden;
  color: #ffffff;
  -webkit-transition: left 0.8s;
  -moz-transition: left 0.8s;
  -o-transition: left 0.8s;
}

.l-d-l {
  left: -260px;
}

.rg {
  position: absolute;
  right: 10px;
  top: 20px;
}

.rg:hover {
  cursor: pointer;
}

.l-t {
  background: #444a67;
  width: 100%;
  font-size: 18px;
  padding: 20px 10px;
  margin-bottom: 20px;
}

.l-d .l-t > div {
  font-size: 12px;
  margin-top: 20px;
}

.l-d .l-t > div img {
  vertical-align: middle;
  margin-top: -3px;
  margin-right: 5px;
}

.img {
  margin-left: 30px;
}

.l-d .el-button + .el-button, .l-d .el-button--small {
  padding: 7px 10px;
  width: 65px;
  height: 36px;
  font-size: 14px;
  color: #ffffff;
  background: #444a67;
  border-radius: 2px;
  border: none;
}

.l-d .el-button--small.a-btn, .l-d .el-button + .el-button.a-btn {
  background-image: url('./assets/images/btna.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.l-btn {
  text-align: center;
  margin-top: 10px;
  margin-bottom: 20px;
}

.l-bot {
  color: #999;
  font-size: 12px;
}

.l-bot img {
  vertical-align: middle;
  margin-top: -2px;
  margin-right: 5px;
}

.l-bot span {
  color: #ffffff;
}

.l-bot div {
  float: right;
}

.lb {
  width: 100%;
  overflow: hidden;
  height: 4px;
  margin: 12px 0;
}

.lb > div.gr {
  background: #00ff9f;
}

.l-cont {
  height: 100%;
  overflow: auto;
}

.l-cont::-webkit-scrollbar {
  display: none;
}

.l-cont ul > div {
  padding: 25px 15px;
  border: 1px solid transparent;
  border-bottom: 1px solid #393a55;
}

.l-cont ul {
  padding-bottom: 300px;
}

.l-cont ul > div.aClick {
  background: rgba(255, 255, 255, 0.1);
}

.l-cont ul > div.a {
  background-image: url('./assets/images/click.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.l-cont h5 {
  margin: 0px;
  font-size: 14px;
}

.l-d > div {
  position: relative;
  height: 100%;
}

.marquee_top {
  transition: all 1s;
  margin-top: -130px;
}

.lb > div {
  width: 100%;
  height: 4px;
  -webkit-animation: loading 1s linear;
  animation: loading 1s linear;
  background: #fb3132;
}

@keyframes loading {
  0% {
    width: 0;
  }

  50% {
    width: 100%;
  }

  100% {
  }
}

.r-d {
  position: absolute;
  right: 15px;
  width: 300px;
  overflow: hidden;
  top: 85px;
  height: 86%;
  background: #2b304c;
  border: 1px solid #3c4161;
  box-shadow: 0 5px 5px 0 rgba(0, 0, 0, 0.1);
  font-size: 14px;
  z-index: 100;
  color: #ffffff;
  -webkit-transition: right 0.8s;
  -moz-transition: right 0.8s;
  -o-transition: right 0.8s;
}

.city-s {
  background: #2b304c;
  border: 1px solid #3c4161;
  box-shadow: 0 5px 5px 0 rgba(0, 0, 0, 0.1);
  width: 280px;
  position: absolute;
  right: 15px;
  padding-right: 0;
  padding-right: 0;
  top: 85px;
  overflow-x: hidden;
  height: 86%;
  color: #ffffff;
  -webkit-transition: right 0.8s;
  -moz-transition: right 0.8s;
  -o-transition: right 0.8s;
  z-index: 100;
  /* overflow: hidden; */
}

.r-dr {
  right: -300px !important;
}

.l-t span {
  font-size: 12px;
  opacity: 0.5;
  margin-bottom: 10px;
}

.l-t h3 {
  margin: 0;
  margin-bottom: 10px;
  font-size: 18px;
}

.marquee_top {
  transition: all 1s;
  margin-top: -130px;
}

.r-d .el-button + .el-button, .r-d .el-button--small {
  padding: 7px;
  width: 70px;
  color: #ffffff;
  background: #152957;
  border: 1px solid #152957;
}

.r-d .el-button--small.a-btn, .r-d .el-button + .el-button.a-btn {
  background: -moz-linear-gradient(
    left,
    #1d6bac 0%,
    #384aab 100%
  );
  /* FF3.6-15 */
  background: -webkit-linear-gradient(
    left,
    #1d6bac 0%,
    #384aab 100%
  );
  /* Chrome10-25,Safari5.1-6 */
  background: linear-gradient(to right, #1d6bac 0%, #384aab 100%);
  border: 1px solid #5a74fc;
}

.l-bot {
  color: #999;
  font-size: 10px;
}

.l-bot span {
  color: #ffffff;
}

.l-bot div {
  float: right;
}

.lb {
  width: 100%;
  overflow: hidden;
  height: 5px;
  margin: 12px 0;
}

.lb > div {
  width: 100%;
  height: 5px;
  background: #fb3132;
}

.lb > div.gr {
  background: #00ff9f;
}

.l-cont > div {
  padding: 20px 15px;
  margin-top: 15px;
  border-bottom: 1px solid #393a55;
}

.l-cont > div.a {
  background: rgba(255, 255, 255, 0.1);
}

.l-cont h5 {
  margin: 0px;
}

.r-d > div {
  position: relative;
  height: 100%;
}

.rb {
  padding: 10px 0;
}

.rb > div {
  display: inline-block;
  width: 33.3%;
  color: #ffffff;
  text-align: center;
  vertical-align: top;
  font-size: 18px;
}

.rb > div div {
  color: #999;
  margin-top: 10px;
  font-size: 10px;
  line-height: 1.5;
}

.rt-l {
  font-size: 18px;
}

.rt {
  display: flex;
  height: 50px;
  position: relative;
  align-items: center;
  padding-bottom: 10px;
}

.rt-r {
  font-size: 12px;
  text-align: left;
  color: #9999;
  position: absolute;
  right: 0px;
}

.rt-r img {
  vertical-align: middle;
  margin-top: -3px;
}

.l-t > div {
  font-size: 10px;
  margin-top: 20px;
}

.l-t > div img {
  vertical-align: middle;
  margin-top: -3px;
  margin-right: 3px;
}

.img {
  margin-left: 30px;
}

.rt-r span {
  margin-left: 5px;
}

.rt-r div {
  margin-top: 5px;
}

.rt-r .font-o {
  color: #ffffff;
  font-size: 10px;
}

.main {
  min-width: 1100px !important;
}

.top-t img {
  vertical-align: middle;
  margin-top: -2px;
  margin-left: 30px;
  margin-right: 3px;
}

.top-r {
  position: absolute;
  right: 5px;
  top: 13px;
}

.top-t span {
  font-size: 14px;
}

.top-t button span {
  font-size: 12px;
}

.top-t div.f {
  font-size: 16px;
  margin-top: 10px;
  margin-right: 30px;
}

.ser {
  display: inline-block;
  width: 300px;
  background: #292d45;
  border-radius: 18px;
  padding: 2px;
  position: relative;
}

.submit {
  position: absolute;
  right: 10px;
  top: 0;
  width: 50px;
  height: 30px;
  cursor: pointer;
}

.way-c .rb {
  margin-top: 5px;
  margin-left: 45px;
}

.ser .el-input__inner {
  background: #292D45;
  border-radius: 18px;
  border: 1px solid #292D45;
  color: #ffffff;
  height: 32px;
  line-height: 32px;
}

.ser .el-input-group__append {
  border-radius: 18px;
  border: 0;
  font-size: 14px;
  background: #444a67;
  color: #646e99;
}

.ser .el-input-group__append:hover {
  cursor: pointer;
}

.way-c {
  height: 91%;
  overflow: auto;
}

.way-c > div {
  padding: 20px 10px;
  width: 320px;
  position: relative;
  display: inline-block;
  border: 1px solid transparent;
  border-bottom: 1px solid #393A55;
  overflow: hidden;
  margin-top: 30px;
}

.way-c > div.a {
  background-image: url('./assets/images/kk.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.way-c h5 {
  margin: 0px;
  color: #ffffff;
}

.way-c .rt-l {
  font-size: 22px;
  color: #ffffff;
}

.way-c .rt {
  display: flex;
  height: 60px;
  margin-left: 45px;
  position: relative;
  align-items: center;
  background: #444a67;
  padding-left: 10px;
  padding-top: 10px;
}

.way-c .rt-r {
  font-size: 12px;
  text-align: left;
  padding-top: 0px;
  color: #9999;
  position: absolute;
  right: 10px;
}

.way-c .rt-r img {
  vertical-align: middle;
  margin-top: -2px;
}

.way-c .rt-r span {
  margin-left: 5px;
}

.way-c .rt-r div {
  margin-top: 5px;
}

span.font1 {
  color: #00f49a;
}

span.font2 {
  color: #f93132;
}

.top-t .el-button + .el-button, .top-t .el-button--small, .top-t .el-button:hover, .top-t .close-btn, .top-t .close-btn:hover {
  padding: 7px 0;
  margin-left: 20px;
  width: 85px;
  color: #ffffff;
  background: #292d45;
  border: none;
  border-radius: 2px;
  margin-top: 5px;
}

.top-t .close-btn {
  float: right;
}

.top-t .el-button--small.a-btn, .top-t .el-button + .el-button.a-btn {
  background-image: url('./assets/images/btna.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
}

.top-t img {
  vertical-align: middle;
  margin-top: -2px;
  margin-left: 30px;
  margin-right: 5px;
}

.top-t {
  color: #ffffff;
  background: #444a67;
  padding: 15px;
  position: relative;
}

.top-t span {
  font-size: 14px;
}

.top-t button span {
  font-size: 12px;
}

.top-t span.f {
  font-size: 16px;
  margin-right: 30px;
}

.top-c .l-bot {
  margin-left: 40px;
}

.top {
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 9999;
  background: #2b304c;
}

.top-c {
  height: 91%;
  padding: 0 15px;
  overflow: auto;
}

.top-c > div {
  padding: 25px;
  width: 300px;
  /* margin-left: 10px; */
  position: relative;
  /* margin-right: 10px; */
  display: inline-block;
  /* border: 1px solid transparent; */
  border-bottom: 1px solid #393A55;
  overflow: hidden;
  margin-top: 20px;
}

.dot {
  position: absolute;
  background: #444a67;
  border-radius: 18px;
  width: 36px;
  font-size: 18px;
  text-align: center;
  line-height: 36px;
  height: 36px;
  top: 50%;
  margin-top: -18px;
  left: 10px;
  color: #ffffff;
}

.top-c h5 {
  margin: 0px;
  color: #ffffff;
  margin-left: 40px;
  font-size: 16px;
}

.top-c img {
  vertical-align: middle;
  margin-top: -2px;
  margin-right: 5px;
}

.top-c .lb {
  width: 90%;
  overflow: hidden;
  height: 4px;
  margin: 12px 0;
  margin-left: 40px;
}

.top-c .lb > div {
  width: 100%;
  height: 4px;
}

.el-message-box {
  background-color: #2B304C;
  border: 1px solid #393E5D;
  padding-top: 10px;
  padding-bottom: 15px;
}

.el-message-box__title, .el-message-box__content {
  color: #fff;
}

.el-message-box .el-button {
  background: #444A67;
  color: #fff;
  border: none;
}

.el-message-box .el-message-box__btns button:nth-child(2) {
  background: #4681FF;
}
</style>
